module.exports = __webpack_public_path__ + "img/23.5ec5eeb7.png";